import {AdresTuru} from "@/enum/AdresTuru";

/**
 * İlçesi eksik, geçersiz ya da başka ilin ilçesi olan adresi tespit eder (DEV-2726 / TDT-3329).
 *
 * Aktarımdan gelen adreslerde ilçe boş (ör. İstanbul/MERKEZ: İstanbul'da Merkez ilçesi yok),
 * ilceler tablosunda olmayan bir id (ör. 973) ya da başka ilin ilçesi olabiliyor. Böyle bir
 * adres uyarı vermeden takibe giriyor ve UYAP XML'ine ilçesiz çıkıyordu.
 *
 * Kural API'deki App\Helpers\Adres\AdresIlceDenetimi ile birebir aynıdır; biri değişirse
 * öteki de değişmeli.
 */

export const ILCE_DUZELTME_ONERISI = "Adresi kalem simgesiyle açıp il ve ilçeyi yeniden seçin.";

/** API'nin XML öncesi kontrolde (xmlReuiredControl) ilçe sorunları için döndürdüğü anahtarlar. */
export const ILCE_HATA_BASLIKLARI: { [anahtar: string]: string } = {
    "Borçlu Adres İlçe": "Borçlu adresinde ilçe eksik veya hatalı",
    "Alacaklı Adres İlçe": "Alacaklı adresinde ilçe eksik veya hatalı",
    "Vekil Adres İlçe": "Vekil adresinde ilçe eksik veya hatalı",
    "Borçlu Vekili Adres İlçe": "Borçlu vekili adresinde ilçe eksik veya hatalı",
};

/** Mernis/Mersis adresinde il-ilçe UYAP'tan gelir, yurt dışı adreste ilçe yoktur. */
const ILCE_GEREKMEYEN_TURLER: number[] = [
    AdresTuru.mernis,
    AdresTuru.yurtdisiev,
    AdresTuru.yurtdisiis,
    AdresTuru.mersis,
];

/** Tür seçilmemişse (null) de ilçe gerekir. */
export function ilceGerekliMi(adresTurId: number | string | null | undefined): boolean {
    return !ILCE_GEREKMEYEN_TURLER.includes(Number(adresTurId));
}

/**
 * Adresin ilçe sorununu kısa gerekçe olarak döner, sorun yoksa null.
 *
 * Sunucu ilişkileri nesne ({id, isim, sehir_id}) ya da JOIN'le ad metni olarak döner,
 * AdresList.onUpdate sonrası ad metnine çevrilir, formdan yeni gelen adreste hiç
 * olmayabilir. "Geçersiz" kararı yalnızca kayıtlı adreste ve sunucunun ilişkiyi (ya da
 * JOIN'le adı) açıkça null döndürdüğü durumda verilir (AdresForm.mounted ile aynı ölçüt).
 *
 * @param kayitli Veritabanından okunmuş adres; verilmezse id'nin varlığına bakılır
 *   (takip detayındaki borçlu adresi id taşımaz).
 */
export function adresIlceSorunu(adres: any, kayitli: boolean = !!(adres && adres.id)): string | null {
    if (!adres || !ilceGerekliMi(adres.adres_tur_id)) {
        return null;
    }
    if (!adres.sehir_id || (kayitli && adres.sehir === null)) {
        return "il seçilmemiş";
    }
    if (!adres.ilce_id) {
        return "ilçe seçilmemiş";
    }
    if (kayitli && adres.ilce === null) {
        return "ilçe kaydı geçersiz";
    }
    const ilce = adres.ilce;
    if (ilce && typeof ilce === "object" && ilce.sehir_id != null
        && Number(ilce.sehir_id) !== Number(adres.sehir_id)) {
        return "ilçe adresin iline ait değil";
    }
    return null;
}

/**
 * Kayıtlı adresin ilce_id'si ilçe seçicide görünmüyorsa (id ilceler'de yok ya da başka ilin
 * ilçesi) seçici boş görünür ama zorunlu kural alanı dolu sayar; AdresForm bunu açılışta
 * temizleyip ilçeyi yeniden seçtirir.
 */
export function seciciIlcesiniTemizlemeliMi(adres: any): boolean {
    return !!(adres && adres.id && adres.ilce_id
        && (adres.ilce === null || adresIlceSorunu(adres) === "ilçe adresin iline ait değil"));
}

/** Sunucudan nesne ({isim}) ya da onUpdate sonrası metin gelen il/ilçe alanının adı. */
export function adresAlanAdi(deger: any): string {
    if (deger == null) {
        return "";
    }
    if (typeof deger === "object") {
        return (deger.isim || "").toString();
    }
    return String(deger);
}
